import { bypassMaintenance } from "../util";
import { TimeResponse } from "../typings";
import { fetchService } from "./fetchService";


const TimeService = {
    isValidLocalTime(offset: number, offsetThreshold: number): boolean {
        console.log("[TimeService] offset offsetThreshold ", offset, offsetThreshold, " THe treshold is set to: ",offset > offsetThreshold,(offset * -1) > offsetThreshold)
        if(offset > offsetThreshold || (offset * -1) > offsetThreshold) {
          return false;
        } else {
          return true;
        }
    },
    getNowUTC(): Date {
        var date = new Date();
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
          date.getUTCDate(), date.getUTCHours(),
          date.getUTCMinutes(), date.getUTCSeconds());
        
        return new Date(now_utc);
      },
      convertDateToUTC(date: Date): Date {
        var utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
          date.getUTCDate(), date.getUTCHours(),
          date.getUTCMinutes(), date.getUTCSeconds());
        
        return new Date(utc);
      },
    timeZone:()=>{
        console.log(`[TimeService][current timezone][${Intl.DateTimeFormat().resolvedOptions().timeZone}]`);  
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    current: ()=>{
        var d = new Date();
        TimeService.timeZone();
        return d.toString();
    },
    init: (cb:any)=>{
        TimeService.timeZone();
           setInterval(()=>{
            var d = new Date();
           cb(d.toLocaleString());
       },1000)
    },
    validateCurrentTime: async (url:string,threshold:number):Promise<TimeResponse>=>{
    return await fetchService(url).then(async (response)=>{
    const responseData = await response.json()
    const dateFromResponse = responseData?.date ? responseData?.date : responseData?.data?.date;
    const isUnderMaintenance = bypassMaintenance() ? false : responseData?.maintenance ?? false
    if(isUnderMaintenance){
      return {passed:false,serverTime:"UnderMaintenance",localTime:JSON.stringify(TimeService.getNowUTC().getTime())};
    }
    if(dateFromResponse){
       const serverTimeUTC = new Date(dateFromResponse);
       const localTimeUTC = TimeService.getNowUTC();
       console.log("[timeservice]",'server time', serverTimeUTC.getTime(), "local time", localTimeUTC.getTime());
       let offset = serverTimeUTC.getTime() - localTimeUTC.getTime();
       const isValid = TimeService.isValidLocalTime(offset, threshold);
       return {passed:isValid,serverTime:JSON.stringify(serverTimeUTC.getTime()),localTime:JSON.stringify(localTimeUTC.getTime())};
    }
    else{
      return {passed:false,serverTime:"NotAvailable",localTime:JSON.stringify(TimeService.getNowUTC().getTime())}
    }
    }).catch((e)=>{
      console.error("[TimeService] the time check failed because: ",e)
      return {passed:false,serverTime:`ErrorFetchingDate: ${e.message}`,localTime:JSON.stringify(TimeService.getNowUTC().getTime())}
    })
    }
    }
    
    export default TimeService;
      